import React from 'react';
import { useRouteError } from 'react-router-dom';
import { MainErrorFallback } from 'components/errors/main';
import errorHandler from 'lib/ErrorHandler';

export const RouteErrorBoundary = () => {
    const error = useRouteError() as Error;

    React.useEffect(() => {
        errorHandler.handleError(error);
    }, [error]);

    return <MainErrorFallback />;
};

export class ErrorBoundary extends React.Component<{
    children: React.ReactNode;
}> {
    state = { hasError: false };

    constructor(props: { children: React.ReactNode }) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_error: Error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        const renderingError = new Error(error.message);
        renderingError.name = `ReactRenderingError`;
        if (info.componentStack) {
            renderingError.stack = info.componentStack;
        }

        errorHandler.handleError(renderingError);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <MainErrorFallback />;
        }

        return this.props.children;
    }
}
